package com.solevo.dist.sections

import androidx.compose.runtime.*
import com.solevo.dist.theme.JsTheme
import com.solevo.dist.util.Res
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import org.jetbrains.compose.web.css.px

/**
 * Created by Ilija Vucetic on 30.9.25..
 * Copyright (c) 2025 Aktiia. All rights reserved.
 */
@Composable
fun DashboardHeader(
    onBellClick: () -> Unit = {},
    rightContent: (@Composable () -> Unit)? = null
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(64.px)
            .styleModifier { property("border-bottom", "1px solid ${JsTheme.Gray.hex}") }
            .gap(16.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(modifier = Modifier.flexGrow(1f))

        Image(
            src = Res.Icon.bellBlack,
            alt = "Bell",
            modifier = Modifier
                .size(24.px)
                .margin(right = 30.px)
                .cursor(Cursor.Pointer)
                .onClick { onBellClick() }
        )

        rightContent?.invoke()
    }
}
